import { type Security, makeTypeGuardByProperty } from '@ipfabric/utils';
import type { SecuritySchemaScope } from 'components/SecuritySchema/model/SecuritySchemaScope';

/**
 * Special scope that is translated to internal security tree scope upon device security load
 *
 * It represents a path to rule that has decided a path lookup event.
 */
export interface DecidingRuleScope {
  type: Security.SecurityType;
  rulePath: Security.RulePath;
  /** (NIM-24333) Cloud (`type === 'cloud'`) only: which direction's machine the check evaluated */
  cloudDirection?: 'inbound' | 'outbound';
}

export type SecuritySchemaEntryPoint = SecuritySchemaScope | DecidingRuleScope;

export const isDecidingRuleEntryPoint = makeTypeGuardByProperty<
  SecuritySchemaEntryPoint,
  DecidingRuleScope
>('rulePath');

export const isSchemaScopeEntryPoint = (
  entryPoint: SecuritySchemaEntryPoint,
): entryPoint is SecuritySchemaScope => !isDecidingRuleEntryPoint(entryPoint);
